import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Faq() {
  const { t } = useTranslation();
  const [open, setOpen] = useState<number | null>(0);

  const items = [1, 2, 3, 4];

  return (
    <section id="faq" className="px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            {t('faq.title')}
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">{t('faq.subtitle')}</p>
        </div>
        <div className="mt-8 flex flex-col gap-3">
          {items.map((i) => (
            <div key={i} className="rounded-lg border border-background-200 bg-background-50 overflow-hidden">
              <button
                type="button"
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between gap-3 px-5 py-4 text-left cursor-pointer"
              >
                <span className="font-heading font-semibold text-foreground-950 text-sm md:text-base">
                  {t(`faq.q${i}.q`)}
                </span>
                <i
                  className={`ri-add-line text-foreground-500 text-lg transition-transform ${
                    open === i ? 'rotate-45' : ''
                  }`}
                />
              </button>
              {open === i && (
                <div className="px-5 pb-4 text-foreground-600 text-sm leading-relaxed">
                  {t(`faq.q${i}.a`)}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}